import axios from "axios";
import { GET_ITEMS, ADD_ITEMS, DELETE_ITEMS, ITEMS_LOADING, INCREASE_ITEMS, DECREASE_ITEMS } from "./types";
import { returnErrors } from "./errorActions"

export const getItems = () => dispatch => {
  dispatch(setItemsLoading());
  axios
    .get("/api/userInformation")
    .then(res =>
      dispatch({
        type: GET_ITEMS,
        payload: res.data
      }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
}

export const getItemsById = (id) => dispatch => {
  dispatch(setItemsLoading());
  if (id !== undefined) {
    id = id.trim();
    if (id.length > 0) {
      axios
        .get(`/api/userInformation/${id}`)
        .then(res => {
          console.log(res.data)
          dispatch({
            type: GET_ITEMS,
            payload: res.data
          })
        })
        .catch(err => dispatch(returnErrors(err.response, err.response)));
    }
    else {
      dispatch({
        type: GET_ITEMS,
        payload: []
      });
    }
  }
}

export const deleteItem = (id) => (dispatch, getState) => {
  alert('calling')
  axios
    .delete(`/api/userInformation/${id}`)
    .then(res =>
      dispatch({
        type: DELETE_ITEMS,
        payload: id
      }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
}

export const increaseItem = (id) => (dispatch, getState) => {

  axios
    .put(`/api/userInformation/${id}`, {

    })
    .then(res =>
      dispatch({
        type: INCREASE_ITEMS,
        payload: id
      }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));

}
export const decreaseItem = (id) => (dispatch, getState) => {

  axios
    .update(`/api/userInformation/${id}`)
    .then(res =>
      dispatch({
        type: DECREASE_ITEMS,
        payload: id
      }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));

}

export const addItem = (item) => (dispatch, getState) => {

  axios
    .post("/api/userInformation", item)
    .then(res =>
      dispatch({
        type: ADD_ITEMS,
        payload: res.data
      }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));

}

export const setItemsLoading = () => {
  return {
    type: ITEMS_LOADING
  }
}
